import React from 'react';

import RufsError from '../../errors/rufsError.jsx';

const PaymentError = () => (
    <RufsError>
        Vi får hevet din handel akkurat nå. Prøv igjen om litt.
    </RufsError>
);

export default PaymentError;



// WEBPACK FOOTER //
// ./safeTrade/seller/payment/cancelTradeError.jsx